import { BitmapCoordinatesRenderingScope } from 'fancy-canvas'
import DrawingBase from '../drawing.base'
import { DrawingTypes, Point, PointCoordinates } from '../drawing.interface'
import { Time } from 'lightweight-charts'
import { scaledCoordinate } from '../drawing.helper'
import { ChartEvents } from '../../chart.events'

export type ZoomInState = {
    p1?: Point,
    p2?: Point
}


class ZoomInTool extends DrawingBase<any, any, ZoomInState> {
    scaledCoordinates = {
        start: 0,
        end: 0
    }

    draw(scope: BitmapCoordinatesRenderingScope) {
        const ctx = scope.context
        this.calculateAttributes()
        const { start, end } = this.scaledCoordinates
        if (!start || !end) return
        ctx.strokeStyle = '#2962ff'
        ctx.lineWidth = window.devicePixelRatio
        ctx.globalAlpha = 0.2
        ctx.fillStyle = '#2962ff'
        ctx.fillRect(Math.min(start, end), 0, Math.abs(end - start), this.canvasHeight)
        ctx.globalAlpha = 1
        ctx.beginPath()
        ctx.moveTo(start, 0)
        ctx.lineTo(start, this.canvasHeight)
        ctx.moveTo(end, 0)
        ctx.lineTo(end, this.canvasHeight)
        ctx.stroke()
        ctx.closePath()
    };

    calculateAttributes() {
        const { p1, p2 } = this._state
        if (p1) {
            let p1x = this.timeToCoordinate(p1.x)

            if (p1x) {
                this.scaledCoordinates.start = scaledCoordinate(p1x, this.horizontalPixelRatio)
            }
        }

        if (p1 && p2) {
            let p2x = this.timeToCoordinate(p2.x)

            if (p2x) {
                this.scaledCoordinates.end = scaledCoordinate(p2x, this.horizontalPixelRatio)
            }
        }
    }

    onAddPoint = (time: Time, price: number, coordinates: PointCoordinates, preview?: boolean) => {
        const { p1, p2 } = this._state
        const point: Point = {
            id: 'p1',
            x: time,
            y: price
        }
        if (!p1) {
            this._state.p1 = point
        } else if (!p2 || preview) {
            point.id = 'p2'
            this._state.p2 = point
        }
        if (p2 && !preview) {
            this.onDrawingEnd()
        }
        if (!preview) return { ...point }
    }

    zoomIn() {
        const { p1, p2 } = this._state

        if (!p1 || !p2) return

        const start = this.timeToLogical(p1.x)
        const end = this.timeToLogical(p2.x)

        if (!start || !end) return

        this._chartApi.timeScale().setVisibleLogicalRange({
            from: Math.min(start, end),
            to: Math.max(start, end)
        })
    }

    onDrawingEnd() {
        this.mode = 'EDIT'
        this.removeMouseMoveHandler()
        this.onDrawingInactive()
        this.onDrawingComplete(this.id)
        this.zoomIn()
        this._chart.publishEvent(ChartEvents.REMOVE_DRAWING, this.id)
    }

    getDrawingType(): DrawingTypes {
        return 'zoomIn'
    }

}

export default ZoomInTool